import * as angular from "angular";

export class TrafficService {

  hide(layer) {
    layer.setMap(null);
  }

  createLayer(map) {
    const layer = new google.maps.TrafficLayer();
    layer.setMap(map);
    return layer;
  }
}

angular
  .module('bringoz.admin.map')
  .service('trafficService', TrafficService);
